var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestFourth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 38,
    viewBox: "0 0 35 38",
    width: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-6 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(7.959835 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 1,
    width: 16,
    x: 8.040165
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.0401651 4h4-.02c2.2-.02 4 1.78 4 3.98v24c0 2.2-1.8 4-4 4h-24.00000003l-.02-.002c-2.22-.02-4.00016507-1.8-4.00016507-4.02v-24c-.01983493-2.22 1.78016507-4.02 3.98016507-4.02h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.5001651 19.7-5.58 5.58-3.36-3.36"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFourth);
export default __webpack_public_path__ + "static/media/request-fourth.c22c2ef6ec7c7a21eadb7cec3e37254c.svg";
export { ForwardRef as ReactComponent };